const state = () => ({
  exams: [],
  firstName: null,
  lastName: null,
  birthday: null,
  gender: null,
})

const getters = {
  exams: (state) => state.exams,
  gender: (state) => state.gender,
  firstName: (state) => state.firstName,
  lastName: (state) => state.lastName,
  birthday: (state) => state.birthday,
}

const mutations = {
  setExams(state, exams) {
    state.exams = exams
  },
  setGender(state, gender) {
    state.gender = gender
  },
  setFirstName(state, firstName) {
    state.firstName = firstName
  },
  setLastName(state, lastName) {
    state.lastName = lastName
  },
  setBirthday(state, birthday) {
    state.birthday = birthday
  },
}

export default {
  state,
  getters,
  mutations,
}
